import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // The hover is the same hairline the outline button uses: the border
          // goes brand-cyan. A field you can click should say so before the
          // caret lands in it, and this is the app's one way of saying it.
          "flex h-10 w-full rounded-md border bg-card px-3 py-2 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground enabled:hover:border-[hsl(var(--ring))] focus-visible:outline-none focus-visible:border-focus focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm text-foreground",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
